export const isElectron = (): boolean => {
  return (
    typeof window !== 'undefined' && typeof window.electron !== 'undefined'
  );
};
